import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styles from "./../styles/HeaderFooterStyles.module.scss";

export class Footer extends Component {
  render() {
    const { colorTheme } = this.props;
    const isDark = colorTheme === 'dark';

    return (
      <footer
        color="inherit"
        className={`${styles.footer} ${isDark ? styles.footerDark : ''}`}
      >
        <div className={styles.footerText}>
          © {moment().year()} Sam's Club. All rights reserved.
        </div>
      </footer>
    );
  }
}
Footer.propTypes = {
  colorTheme: PropTypes.string
};

export default Footer;